import initReviewImageCarousel from "components/jiffy/review-image-carousel/review-image-carousel";

document.addEventListener("DOMContentLoaded", initReviewImageCarousel);
